import SurveyRouteConfig from './SurveyRouteConfig';

export default SurveyRouteConfig;
